export const fetchUsersCount = async () => {
    try {
        const response = await fetch(`/open/users/count`, {
            method: "GET",
            credentials: 'include' // include cookies in the request
        });
        return await response.json();
    } catch (err) {
        console.error('Error fetching total useres data:', err);
    }
}